<template>
  <v-container fluid class="px-16 my-4">
    <v-card
            tile
            class="mtfont"
    >
      <v-container class="pa-6">
        <v-row>
          <v-col cols="7" class="py-0">ACCOUNT</v-col>
          <v-spacer></v-spacer>
        </v-row>
      </v-container>
    </v-card>
    <v-btn text color="white" v-on:click="$router.replace({name: 'Mixer'})">
      <v-icon class="pr-1">arrow_back</v-icon>
      Back to Formulas
    </v-btn>
    <SavedFormulaTable />
  </v-container>
</template>

<script>
import SavedFormulaTable from '@/components/Account/SavedFormulaTable.vue';

export default {
  name: 'Account',

  data: () => ({
    dialog: false
  }),
  components: {
    SavedFormulaTable
  },
  methods: {
  }
}
</script>

<style scoped>

</style>